var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('report-summary',{attrs:{"cases":_vm.cases,"title":_vm.title,"reportDistrict":_vm.reportDistrict,"reportDate":_vm.reportDate,"formName":_vm.formName,"appendixNumber":_vm.appendixNumber,"reportHeader":_vm.reportHeader}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }